import React, { useEffect, useState, useRef } from "react"
import { deleteFlightData, getGCSFlightPilots, getGCSFlightPilotsGraphStats, getGCSFlightPilotsStats, getGCSFlights } from "../../api"
import InteractiveGraph from "../Components/InteractiveGraph"
import FlightsFilter from "../Components/FlightsFilter/FlightsFilter"
import "../Flights/Flights.css"
import TableView from "../../ReusableComponents/TableView/TableView"
import { useHistory } from "react-router-dom"
import { getFlightTime } from "../Flights/Flights"
import { BreadCrumbs } from "../../ReusableComponents/BreadCrumbs.js"
import { Popup, addUserAnalytic, updateOutTime } from "../../ReusableComponents/reusableFunctions.js"
import Cookies from "universal-cookie"
import LoaderComponent from "../../ReusableComponents/LoaderComponent.js"
import { useFirstRender } from "../../ReusableComponents/firstRender.js"
import { GCS_FEATURES, getFeaturesPermissions } from "../../Teams/index.js"
import { ActivityPopup } from "../../ReusableComponents/ActivityPopup.js"
import flightReplay from "../../replayVideo.svg";
import dateFormat from 'dateformat';
import InMaintenanceIcon from '../../InMaintenanceIcon.svg';
import { useIsFreePlan } from "../../redux/Profile/useSubscription";
import { FEATURE_NOT_AVAILABLE_FOR_FREE_USERS_MESSAGE, FREE_PLAN_FLIGHT_ACCESS_DAYS } from "../../AppConstants";

const Pilots = (props) => {
    const cookies = new Cookies()
    const history = useHistory();
    const { user } = props.location.state
    const isFreePlan = useIsFreePlan();
    const [flights, setFlights] = useState([])
    const [flightsPilotsStats, setPilotsFlightsStats] = useState(null)
    const [flightsPilotsGraphStats, setFlightsPilotsGraphStats] = useState(null)
    const [flightsPilots, setFlightsPilot] = useState(null)
    const [pilotsTableState, setPilotsTableState] = useState({ pageNumber: 1, pageSize: 15, orderBy: "total_flights", orderType: "DESC" })
    const [flightsTableState, setFlightsTableState] = useState({ pageNumber: 1, pageSize: 15 })
    const [filterState, setFilterState] = useState(null)
    const [flightsTableLoading, setFlightsTableLoading] = useState(true)
    const [flightsPilotTableLoading, setFlightsPilotTableLoading] = useState(true)
    const [cookieData, setCookieData] = useState()
    const [permissions, setPermissions] = useState()
    const [activityPopup, setActivityPopup] = useState(undefined)
    const [deleteData, setDeleteData] = useState(undefined)
    const [outId, setOutId] = useState("")

    const initialLoadComplete = useRef(false)
    const didMount = useRef(false)

    const getFlights = async () => {
        try {
            setFlightsTableLoading(true)
            const flights = await getGCSFlights({ ...filterState, ...flightsTableState })
            setFlights(flights)
            setFlightsTableLoading(false)
        }
        catch (e) {
            Popup.alert("ERROR", e?.message || e)
            setFlightsTableLoading(false)
        }
    }

    const getFlightsStats = async () => {
        try {
            setPilotsFlightsStats(null)
            const flightsPilotsStats = await getGCSFlightPilotsStats({ ...flightsTableState, ...filterState })
            setPilotsFlightsStats(flightsPilotsStats)
        }
        catch (e) {
            Popup.alert("ERROR", e?.message || e)
        }
    }

    const getFlightsGraphStats = async () => {
        try {
            setFlightsPilotsGraphStats(null)
            const flightsPilotsGraphStats = await getGCSFlightPilotsGraphStats(filterState)
            setFlightsPilotsGraphStats(flightsPilotsGraphStats)
        }
        catch (e) {
            Popup.alert("ERROR", e?.message || e)
        }
    }

    const getFlightsPilots = async () => {
        try {
            setFlightsPilotTableLoading(true)
            const flightsPilots = await getGCSFlightPilots({ ...filterState, ...pilotsTableState })
            setFlightsPilot(flightsPilots)
            setFlightsPilotTableLoading(false)
        } catch (e) {
            setFlightsPilotTableLoading(false)
            Popup.alert("ERROR", e?.message || e)
        }
    }

    useEffect(() => {
        if (!initialLoadComplete.current) return;
        if (filterState) {
            const page_data = cookies.get("page_data") || {};
            const newPageData = {
                ...page_data,
                pilots: {
                    ...page_data?.pilots,
                    ...filterState,
                    ...(filterState?.selectedDrone && { selectedDrones: [filterState.selectedDrone] })
                }
            };
            cookies.set('page_data', JSON.stringify(newPageData), { path: "/" })
            getFlightsGraphStats()
            getFlightsStats()
            getFlightsPilots()
            getFlights()
        }
    }, [filterState])

    useEffect(() => {
        if (!initialLoadComplete.current) return;
        if (flightsTableState) {
            const page_data = cookies.get("page_data") || {};
            const newPageData = { ...page_data, pilots: { ...page_data?.pilots, flightsTableState: flightsTableState } }
            cookies.set('page_data', JSON.stringify(newPageData), { path: "/" })
            getFlights()
        }
    }, [flightsTableState])

    useEffect(() => {
        if (!initialLoadComplete.current) return;
        if (pilotsTableState) {
            const page_data = cookies.get("page_data") || {};
            const newPageData = { ...page_data, pilots: { ...page_data?.pilots, pilotTablePageNumber: pilotsTableState.pageNumber } }
            cookies.set('page_data', JSON.stringify(newPageData), { path: "/" })
            getFlightsPilots()
        }
    }, [pilotsTableState])

    useEffect(() => {
        if (initialLoadComplete.current) return;
        const loadInitialData = async () => {
            const page_data = cookies.get("page_data");
            const data = page_data?.pilots || {};

            if (data?.pilotTablePageNumber) setPilotsTableState(prev => ({ ...prev, pageNumber: data.pilotTablePageNumber }))
            if (data?.flightsTablePageNumber) setFlightsTableState(prev => ({ ...prev, pageNumber: data.flightsTablePageNumber }))
            setCookieData(data)

            const selectedTab = props.location.state?.interval || data?.selectedTab || 'Today';
            let fromDateTime, toDateTime;
            if (selectedTab === 'Today') {
                const now = new Date();
                fromDateTime = new Date(now.setHours(0, 0, 0, 0)).toISOString();
                toDateTime = new Date(now.setHours(23, 59, 59, 999)).toISOString();
            } else {
                fromDateTime = data?.fromDateTime;
                toDateTime = data?.toDateTime;
            }

            const initialFilterState = props.location.state?.filterState || {
                selectedTab,
                selectedDrone: props.location.state?.selectedDrone || data?.selectedDrones?.[0],
                selectedPilot: data?.selectedPilots?.[0],
                fromDateTime,
                toDateTime,
            };

            const [id, permissions] = await Promise.all([
                addUserAnalytic(props.location.pathname),
                getFeaturesPermissions([GCS_FEATURES.PLANS])
            ]);
            setOutId(id);
            setPermissions(permissions);
            initialLoadComplete.current = true;
            setFilterState(initialFilterState);
        };
        loadInitialData();
        if (props.location.state && props.location.state.filterState) {
            setFilterState(props.location.state.filterState);
        }
        didMount.current = true;
    }, [])

    useEffect(() => {
        if (!didMount.current) return;
        if (filterState && (!props.location.state || JSON.stringify(props.location.state.filterState) !== JSON.stringify(filterState))) {
            history.replace({ pathname: props.location.pathname, state: { ...props.location.state, filterState } });
        }
    }, [filterState])

    const firstRender = useFirstRender()
    useEffect(() => {
        if (!firstRender)
            if (flightsTableState) {
                const page_data = cookies.get("page_data");
                const newPageData = { ...page_data, pilots: { ...page_data?.pilots, flightsTablePageNumber: flightsTableState.pageNumber } }
                cookies.set('page_data', JSON.stringify(newPageData), { path: "/" })
                getFlights()
            }
    }, [flightsTableState])

    useEffect(() => {
        if (!firstRender)
            if (pilotsTableState) {
                const page_data = cookies.get("page_data");
                const newPageData = { ...page_data, pilots: { ...page_data?.pilots, pilotTablePageNumber: pilotsTableState.pageNumber } }
                cookies.set('page_data', JSON.stringify(newPageData), { path: "/" })
                getFlightsPilots()

            }
    }, [pilotsTableState])

    useEffect(() => {
        if (!cookieData) {
            const page_data = cookies.get("page_data");
            const data = page_data?.pilots || {}
            if (data?.pilotTablePageNumber)
                setPilotsTableState(prev => ({ ...prev, pageNumber: data.pilotTablePageNumber }))
            if (data?.flightsTablePageNumber)
                setFlightsTableState(prev => ({ ...prev, pageNumber: data.flightsTablePageNumber }))
            setCookieData(data)
        }
        addUserAnalytic(props.location.pathname).then(id => { setOutId(id) })
        getFeaturesPermissions([GCS_FEATURES.PLANS]).then(permissions => { setPermissions(permissions) })
    }, [])

    useEffect(() => { return () => { updateOutTime(outId) } }, [outId])

    const getCookieData = () => {
        return cookies.get("page_data")
    }

    const closeActivityPopup = () => {
        setActivityPopup(undefined)
    }

    const deleteFlight = async () => {
        try {
            setActivityPopup({
                open: true,
                msg: 'Deleting flight and related data please wait...',
                item: "WAIT",
                icon: "WAIT",
            })
            const data = await deleteFlightData(deleteData.id)
            setActivityPopup({
                open: true,
                msg: data.message,
                item: "COMPLETE",
                icon: "COMPLETE",
            })
            setDeleteData(undefined)
            getFlightsGraphStats()
            getFlightsStats()
            getFlightsPilots()
            getFlights()
        }
        catch (e) {
            setDeleteData(undefined)
            closeActivityPopup()
            Popup.alert("ERROR", e?.message || e)
        }

    }

    const rowHeightVH = 10;
    const maxRows = 5;
    const rowCount = Math.min(flightsPilots?.length || 0, maxRows);
    const computedHeight = `${Math.min(rowHeightVH * rowCount, rowCount < 5 ? 28 : 40)}vh`;

    return <div className="wrapper" style={{ fontFamily: 'Lato' }}>
        <div className="right-content-new">
            <div className="top-bar-new">
                <div className="top-bar-text-new">
                    <BreadCrumbs
                        data={[
                            {
                                displayName: "Home",
                                pathname: "/",
                                state: {
                                    user
                                }
                            },
                            {
                                displayName: 'Pilots',
                            }
                        ]} />
                </div>
            </div>
            <div className="main-content-new flights-main-content" >
                <ActivityPopup
                    item={activityPopup?.item}
                    open={activityPopup?.open}
                    icon={activityPopup?.icon}
                    msg={activityPopup?.msg}
                    close={() => { closeActivityPopup() }}
                    onClickOk={() => { deleteFlight() }}
                />
                {
                    cookieData ?
                        <>
                            <FlightsFilter
                                stats={{
                                    "Total Pilots": `${flightsPilotsStats?.totalPilots ? flightsPilotsStats?.totalPilots : 0}`,
                                    "Active Pilots": flightsPilotsStats?.activePilots || 0,
                                    "Inactive Pilots": flightsPilotsStats?.inActivePilots || 0,
                                    "No. of Flights": flightsPilotsStats?.totalFlights || 0,
                                    "Utilize Drones": flightsPilotsStats?.total_drones_utilize || 0,
                                }}
                                cookiesData={cookieData.pageNumber}
                                selectedTab={filterState?.selectedTab || props.location.state?.interval || cookieData?.selectedTab}
                                selectedDrone={filterState?.selectedDrones?.[0] || props.location.state.selectedDrone || cookieData?.selectedDrones?.[0]}
                                selectedPilot={filterState?.selectedPilot || cookieData?.selectedPilots?.[0]}
                                defaultFromDateTime={filterState?.fromDateTime || cookieData?.fromDateTime}
                                defaultToDateTime={filterState?.toDateTime || cookieData?.toDateTime}
                                filterState={{ ...flightsTableState, ...filterState }}
                                onFilterDataChange={(data) => {
                                    if (data.refresh !== 1) {
                                        setFlightsTableState(prev => ({ ...prev, pageNumber: 1 }))
                                        setPilotsTableState(prev => ({ ...prev, pageNumber: 1 }))
                                    }
                                    const { pageNumber, ...rest } = data;
                                    setFilterState(rest)
                                }}
                                isPilotEnable={false}
                            />
                            <InteractiveGraph
                                showZoom
                                data={flightsPilotsGraphStats?.length > 1 ? flightsPilotsGraphStats : []}
                                loading={!flightsPilotsGraphStats}
                                lineType={0}
                                fromDate={filterState?.fromDateTime}
                                interval={filterState?.selectedTab?.toLowerCase() || undefined}
                            />
                            <div style={{ height: computedHeight, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                                <div style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}> {/* THIS IS THE KEY */}
                                    <TableView
                                        pageNumber={cookies.get("page_data")?.pilots?.pilotTablePageNumber || 1}
                                        showSrNo
                                        isLoading={flightsPilotTableLoading}
                                        onStateChange={setPilotsTableState}
                                        columns={[

                                            { Header: "Pilot Name", accessor: "pilot_name", width: '25%', isSortable: true },
                                            { Header: "Flights", accessor: "total_flights", width: '20%', isSortable: true },
                                            { Header: "Acres", accessor: "total_area_covered", width: '25%', isSortable: true },
                                            { Header: "Hours Worked", accessor: "total_flight_time", width: '25%', isSortable: true }
                                        ]}
                                        count={flightsPilotsStats?.totalPilots}
                                        data={flightsPilots?.map((pilot) => {
                                            return ({
                                                ...pilot,
                                                total_flight_time: getFlightTime(pilot.total_flight_time),
                                                total_area_covered: (Number(pilot.total_area_covered) / 4046.85642).toFixed(4)
                                            })
                                        }) || []}
                                    />
                                </div>
                            </div>

                            <div className="table-container" style={{ height: "94%" }}>
                                <TableView
                                    pageNumber={cookies.get("page_data")?.pilots?.flightsTablePageNumber || 1}
                                    isLoading={flightsTableLoading}
                                    tableHeight
                                    onClickRow={(flight) => {
                                        delete flight.maintencance_icon
                                        delete flight.link_data
                                        history.push('/aerogcsenterprise/remote_mission/flight_details', {
                                            user: user,
                                            flightId: flight.id,
                                            fromScreen: "Pilots"
                                        });
                                    }}
                                    onStateChange={setFlightsTableState}
                                    headingLeft={"Flights"}
                                    columns={[
                                        { Header: '', accessor: 'maintencance_icon', isSortable: false, isCenter: true, onHoverText: 'Drone is in maintenance' },
                                        { Header: "Project/Plan Name", accessor: "projectPlanName", width: '15%' },
                                        { Header: "Drone", accessor: "drone_name", width: '11%', isSortable: true },
                                        { Header: "Start/End Time", accessor: "flightDate", width: '20%', },
                                        { Header: "Total Time", accessor: "total_flight_time", width: '10%', isSortable: true },
                                        { Header: "Distance (M)", accessor: "distance_covered", width: '10%', isSortable: true },
                                        { Header: "Sprayed Area (Acr)", accessor: "area_covered", width: '12%', isSortable: true },
                                        { Header: "Acres by Pilot", accessor: "acres", width: '12%', isSortable: true },
                                        { Header: "Consumed Liquid (ml)", accessor: "consumed_liquid", width: '12%', isSortable: true },
                                        { Header: "Replay", accessor: "link_data", width: '5%', isIcon: true, isCenter: true },
                                    ]}
                                    count={flightsPilotsStats?.totalFlights}
                                    data={flights?.map((flight) => {
                                        // Check if flight.end_time is more than 7 days ago and user is on free plan
                                        let hasNoAccessForFreePlan = false;
                                        if (isFreePlan) {
                                            const endTime = new Date(flight.end_time);
                                            const today = new Date();
                                            const daysDifference = (today - endTime) / (1000 * 60 * 60 * 24); // Convert milliseconds to days
                                            hasNoAccessForFreePlan = daysDifference > FREE_PLAN_FLIGHT_ACCESS_DAYS;
                                        }

                                        return ({
                                            ...flight,
                                            maintencance_icon: flight.is_drone_in_maintenance ? <img style={{ width: "20px", height: '20px' }} src={InMaintenanceIcon} /> : undefined,
                                            flightDate: `${dateFormat(flight.start_time, "dd/mm/yyyy hh:MM TT")} / ${dateFormat(flight.end_time, "hh:MM TT")}`,
                                            hasNoAccessForFreePlan: hasNoAccessForFreePlan,
                                            projectPlanName: `${flight.project_name}/${flight.plan_name}`,
                                            total_flight_time: getFlightTime(flight.total_flight_time),
                                            area_covered: (Number(flight.area_covered) / 4046.85642).toFixed(4),
                                            link_data: {
                                                img: flightReplay,
                                                onClick: (flight) => { 
                                                    if (isFreePlan) {
                                                        Popup.alert("WARNING_NOTE", FEATURE_NOT_AVAILABLE_FOR_FREE_USERS_MESSAGE, () => {
                                                            history.push("/aeroGCS_plans", { user: user, serviceName: "AeroGCS Enterprise", currentPlan: user.sub });
                                                        }, () => { });
                                                    } else {
                                                        props.history.push("/aerogcsenterprise/drone_control_center/fly_view", { flight: flight.id, user: user, replyData: 0 })
                                                    }
                                                }
                                            }
                                        })
                                    }) || []}
                                    activities={{
                                        disableDelete: !permissions?.[GCS_FEATURES.PLANS]?.DELETE,
                                        onClickDelete: (flight) => {
                                            setDeleteData(flight)
                                            setActivityPopup({
                                                open: true,
                                                msg: 'Are you sure you want to delete selected flight and related data. (ie. streaming video, images, flight logs) ?',
                                                item: "WARNING",
                                                icon: "WARNING",
                                            })
                                        }
                                    }}
                                    user={user}
                                />
                            </div>
                        </>
                        : <LoaderComponent />
                }
            </div>
        </div>
    </div >
}
export default Pilots